import { Controller, useFormContext } from 'react-hook-form';

import useTranslation from '@/utils/hooks/translation/useTranslation';

//type
import type { PlatformFormType } from '@/components/pages/settings/platform/types';

//libs
import { platform_language } from '@/lib/settings/optionsConfiguration/platformSettings/platform-settings';

//components
import { SelectComponent } from '@/components/base/Select/SelectComponent/SelectComponent';

export function PlatformLanguage() {
    const { t } = useTranslation('settings');

    const options = platform_language(t);

    const {
        control,
        formState: { errors }
    } = useFormContext<PlatformFormType>();

    return (
        <Controller
            key={'platform_language'}
            control={control}
            name={'platform_language'}
            render={({ field: { onChange, value } }) => {
                return (
                    <SelectComponent
                        selected={options?.find((item) => value['value'] === item.value)}
                        setSelected={onChange}
                        label={t('platform_page.platform_language')}
                        error={errors.platform_language?.message}
                        options={options}
                    />
                );
            }}
        />
    );
}
